import {httpsCallable} from "@firebase/functions";
import {NotificationDTO} from "./models/NotificationDTO";
import {Notification} from "./models/Notification";
import {functions} from "../firebase/config/config";
import {LastUserLocation} from "./models/LastUserLocation";

export const createNotification = async (notificationDTO: NotificationDTO) => {
    try {
        const region = 'europe-west6';
        const projectId = functions.app.options.projectId;
        const functionUrl = `https://${region}-${projectId}.cloudfunctions.net/httpSendTargetedNotification`;

        const personalReferences: string[] = notificationDTO.users.map(
            (user: LastUserLocation) => user.personalReference
        );
        const data = {
            personalReferences: personalReferences,
            source: "TRAVELSAFETY",
            users: notificationDTO.users,
            notification: notificationDTO.notification,
            isSilent: false,
            context: {
                users: notificationDTO.users,
            },
        };

        const response = await fetch(functionUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {
            return {message: "The notification has been created."};
        } else {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    } catch (error: any) {
        throw error;
    }
}

const httpGetUserLocations = httpsCallable(functions, 'httpGetUserLocations');
export const getUserLocations = async () => {
    try {
        const result = await httpGetUserLocations();
        return result.data as LastUserLocation[];
    } catch (error: any) {
        throw error;
    }
}

const httpGetNotifications = httpsCallable(functions, 'httpGetNotificationHistory');
export const getNotifications = async () => {
    try {
        const result = await httpGetNotifications();
        return result.data as Notification[];
    } catch (error: any) {
        throw error;
    }
}
